import { createAction } from '@reduxjs/toolkit';

export const initApp = createAction('initApp/initApp');
